import { BrowserRouter, Route, Routes } from "react-router-dom";

import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<PublicRoutes />} />
        <Route path="/dashboard/*" element={<PrivateRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
